export const getHighestRole = (roles = []) => {
  const ROLE_PRIORITY = ["Admin", "Manager", "Employee", "User"];
  return ROLE_PRIORITY.find((role) => roles.includes(role));
};
